// 计费分类管理

import { HttpCusbillTemplateList, HttOperaTemplateOne } from '@/service/billing';
import TableList from "@components/templates/tablelist";
// import { mapGetters } from 'vuex';
import comSetCode from './setcode'

export default {
    mixins: [TableList],
    components: {
        comSetCode
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    EQ_type: '1',
                }
            },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
            Plugins: { show: true },
        };
    },
    methods: {
        ajaxRequest: HttpCusbillTemplateList,
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one', { defaultValue: '请选择至少一条数据' }));
            }
            const temptype = this.formData.search.EQ_type;
            switch (type) {
                case 'add':
                    this.operate = {
                        show: true,
                        alert: "info",
                        title: this.$t('fbb.accountmanage.add_template', { defaultValue: "添加模板" }),
                        width: 460,
                        component: "comSetCode",
                        temptype: temptype,
                        showFooter: false,
                    };
                    break;
                case 'edit':
                    sessionStorage.setItem('billtemplate', JSON.stringify(params))
                    this.$router.push({
                        name: 'customerRateTemplateupdate',
                        params: { type: "edit" },
                        query: { id: params.id, temptype: temptype },
                    });
                    break;
                case 'failure':
                    this.operate = {
                        show: true,
                        alert: "error",
                        params: { id: params, status: 1 },
                        title: this.$t('fbb.accountmanage.operate_loss_effect', { defaultValue: "失效操作" }),
                        ajaxRequest: HttOperaTemplateOne
                    }
                    break;
                case 'active':
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params: { id: params, status: 0 },
                        title: this.$t('fbb.accountmanage.active_opearte', { defaultValue: "激活操作" }),
                        ajaxRequest: HttOperaTemplateOne
                    }
                    break;
                
            }
        },
        getOperateNodeMap(row) {
            // console.log(row)
            const { id, status } = row;
            return [{
                label: this.$t('global.common.edit', { defaultValue: '编辑' }),
                show: true,
                params: row,
                operate: 'edit'
            }, {
                label: this.$t('fbb.accountmanage.loss_effect', { defaultValue: '失效' }),
                show: status == 0,
                params: id,
                operate: 'failure'
            },
            {
                label: this.$t('fbb.accountmanage.active', { defaultValue: '激活' }),
                show: status == 1,
                params: id,
                operate: 'active'
            },
            ]
        },
    },
    computed: {
        // ...mapGetters('dictionary', ['getSysorgList']),
        TabsData() {
            return [
                {
                    name: this.$t('fbb.billing.operatefeedetail', { defaultValue: "仓库作业费" }),
                    key: 'EQ_type',
                    val: '1'
                }, {
                    name: this.$t('fbb.billing.storagefeedetail', { defaultValue: "仓储费" }),
                    key: 'EQ_type',
                    val: '4'
                }, {
                    name: this.$t('fbb.accountmanage.materiral_cost', { defaultValue: "包材费" }),
                    key: 'EQ_type',
                    val: '5'
                }, {
                    name: this.$t('fbb.accountmanage.more_service_cost', { defaultValue: "增值服务费" }),
                    key: "EQ_type",
                    val: '3'
                }
            ]
        },
        ToolsData() {
            return [
                {
                    name: this.$t('global.common.add', { defaultValue: "添加" }),
                    operate: "add",
                    theme: "primary",
                },
                
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('fbb.accountmanage.template_code', { defaultValue: "模板Code" }),
                    key: 'CN_code',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: this.$t('fbb.accountmanage.template_name', { defaultValue: "模板名称" }),
                    key: 'CN_name',
                    tag: 'vInput',
                    show: true,
                },
                {
                    label: this.$t('global.common.status', { defaultValue: "状态" }),
                    key: 'EQ_status',
                    show: true,
                    tag: 'vSelect',
                    options: [
                        { value: 0, label: this.$t('fbb.accountmanage.has_effect', { defaultValue: '有效' }) },
                        { value: 1, label: this.$t('fbb.accountmanage.no_effect', { defaultValue: '无效' }) },
                    ],
                },
            ]
        },
        columns() {
            return [
                {
                    type: 'selection',
                    width: 40,
                    align: 'center',
                    formName: 'id'
                },
                {
                    title: this.$t('global.common.operation', { defaultValue: '操作' }),
                    maxWidth: 90,
                    render: this.getOperateNodes
                }, {
                    title: this.$t('fbb.accountmanage.template_code', { defaultValue: '模板Code' }),
                    key: 'code',
                }, {
                    title: this.$t('fbb.accountmanage.template_name', { defaultValue: '模板名称' }),
                    key: 'name',
                }, {
                    title: this.$t('fbb.accountmanage_cost_currency', { defaultValue: '计费币种' }),
                    key: 'currency',
                }, {
                    title: this.$t('global.common.status', { defaultValue: "状态" }),
                    key: 'status',
                    render: (h, { row }) => row.status == 1 ? this.$t('fbb.accountmanage.no_effect', { defaultValue: '无效' }) : this.$t('fbb.accountmanage.has_effect', { defaultValue: '有效' }),
                }, {
                    title: this.$t('global.common.notes', { defaultValue: '备注' }),
                    key: 'remark',
                }, {
                    title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                    key: 'createdAt',
                }];
        },
    },
};




